import client from './client';

export const listSuburbs = (params) =>
  client.get('/suburbs', { params }).then((r) => r.data);

export const createSuburb = (data) =>
  client.post('/suburbs', data).then((r) => r.data);

export const updateSuburb = (id, data) =>
  client.put(`/suburbs/${id}`, data).then((r) => r.data);

export const deleteSuburb = (id) =>
  client.delete(`/suburbs/${id}`).then((r) => r.data);
